import React from 'react'

import { SchemaJavaScriptDefinition } from './SchemaDefinition'
import { JavaScriptDefinition } from './TypedDefinition'
import { JavaScriptNode } from './TypedNode'
import { JavaScriptComponent } from './ViewComponent'

import type { JavaScriptImports } from './types'
import type { PluginVisitors, RehajePlugin } from '@rehaje/core'

export interface JavaScriptPluginProps {
  classNamePrefix?: string
  enableErrorCapture?: boolean
  enableRefactor?: boolean
  getProxyHandler?: (node: JavaScriptNode) => ProxyHandler<any>
  imports?: JavaScriptImports
}

/**
 * 插值表达式插件
 */
export class JavaScriptPlugin implements RehajePlugin {
  props: JavaScriptPluginProps

  visitors: PluginVisitors = {
    components: {
      JavaScript: JavaScriptComponent
    },
    definitions: {
      JavaScript: JavaScriptDefinition,
      'Schema.JavaScript': SchemaJavaScriptDefinition
    },
    nodes: {
      JavaScript: JavaScriptNode
    }
  }

  constructor(props: JavaScriptPluginProps = {}) {
    this.props = {
      imports: {
        react: React,
        ...props.imports
      },
      ...props
    }
  }

  static loadJavaScriptStorage = async () => {
    return JavaScriptNode.loadJavaScriptStorage()
  }

  static useJavaScriptStorage() {
    return JavaScriptNode.useJavaScriptStorage()
  }
}
